import React from "react";
import PilotCheckout from "../../../utils/PilotCheckout";
import { numberSpacing } from "../../../utils/function";
import { useSelector } from "react-redux";
import { getData } from "../../../utils/storage";
import BuylineCalculator from "../BuylineCalculator";
import "./cart.css";
import BuylineFinanceCalculator from "../BuylineFinanceCalculator";

function CartLeft({ cart, manufactured }) {
  let info = localStorage.getItem("plate-info");
  const resBuyline = useSelector((s) => s.buyline.data.enable);
  const isBuylineEnable = resBuyline;
  const imgUrl = isBuylineEnable ? "/img/visa.png" : "/img/visa3.png";

  return (
    <>
      <div className="col-md-4">
        <div className="order-checkout-card">
          <div className="order-checkout-card-title">
            <h2>{numberSpacing(cart.category, cart.fullNumber)}</h2>
            <p>
              This registration is only suitable for vehicles manufactured{" "}
              <span>{info ? info : manufactured + "."}</span>
            </p>
          </div>
          <ul className="order-summary-list">
            <li>
              <h3>Registration:</h3>
              <span>£{parseFloat(cart.price).toFixed(2)}</span>
            </li>
            <li>
              <h3>VAT:</h3>
              <span>£{parseFloat(cart.vat).toFixed(2)}</span>
            </li>
            <li>
              <h3>Compulsory DVLA Fee:</h3>
              <span>£{cart.dvlaFee}</span>
            </li>
            {cart.fastCheckout ? (
              <li>
                <h3>Registration Transfer Service:</h3>
                <span>£{cart.fastCheckout}</span>
              </li>
            ) : null}
            <li>
              <h3>Physical Number Plate(s):</h3>
              <span>£{cart.plate_type}</span>
            </li>

            <li>
              <h3>Coupon{cart.coupon ? `(${cart.coupon})` : ""}:</h3>
              <span>
                £
                {cart.coupon_value
                  ? parseFloat(cart.coupon_value).toFixed(2)
                  : 0}
              </span>
            </li>
            <li>
              <h2>
                Total:
                <span>
                  £
                  {(
                    parseFloat(cart.price) +
                    parseFloat(cart.dvlaFee) +
                    parseFloat(cart.vat) +
                    parseFloat(cart.fastCheckout) +
                    parseFloat(cart.plate_type)
                  ).toFixed(2)}
                </span>
              </h2>
            </li>
            {isBuylineEnable ? (
              <li>
                <>
                  <BuylineFinanceCalculator
                    term={48}
                    apr={19.9}
                    theme={1}
                    price={(
                      parseFloat(cart.price) +
                      parseFloat(cart.dvlaFee) +
                      parseFloat(cart.vat) +
                      parseFloat(cart.fastCheckout) +
                      parseFloat(cart.plate_type)
                    ).toFixed(2)}
                  />
                </>
              </li>
            ) : null}
          </ul>
          <div className="order-checkout-card-title-img">
            <img src={imgUrl} />
          </div>
        </div>
        <div className="tpr">
          <PilotCheckout />
        </div>
      </div>
    </>
  );
}

export default CartLeft;
